export default function() {
  return new Worker(__webpack_public_path__ + "main.fd512a7db9a3f59d46eb.worker.js");
}
